module.exports = __webpack_public_path__ + "static/media/bg4.8dae103f.jpg";